/**
 * @file dhx-checkbox.component.tsx
 * @description Компонент работы с чекбоками у списков групп в каталогах. Испоьльзуется библиотека @dhx/suite.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies []
 * @related-files []
 */

import { useId } from 'react';
import cn from 'classnames';
import { Text } from '@consta/uikit/Text';

/**
 * Props для компонента DhxCheckbox
 */
interface IDhxCheckboxProps {
    /** Состояние чекбокса (отмечен/не отмечен) */
    checked: boolean;
    /** Обработчик изменения состояния */
    onChange: (checked: boolean) => void;
    /** Текст заголовка чекбокса */
    title: string;
    /** CSS класс для дополнительной стилизации */
    className?: string;
}

export const DhxCheckbox = ({ checked, onChange, title, className }: IDhxCheckboxProps) => {
    const id = useId();

    return (
        <div className={cn('flex', className)}>
            <div
                id={`useFilterControl_${id}`}
                className={cn('dhx_tree-checkbox dxi', {
                    'dxi-checkbox-blank-outline': !checked,
                    'dxi-checkbox-marked': checked
                })}
                onClick={() => {
                    onChange(!checked);
                }}
            />
            <label htmlFor="useFilterControl">
                <Text size="m" className="text-[1.4832vmin]">
                    {title}
                </Text>
            </label>
        </div>
    );
};
